<script setup lang="ts">
/**
 * Modale Messages : ouvre la vue Inbox en overlay (pilotée par overlays.store)
 * au lieu d'une navigation pleine page. La route /inbox reste un deep-link.
 */
import { computed } from 'vue';
import { useOverlaysStore } from '@/stores/overlays.store';
import InboxView from '@/views/game/InboxView.vue';

const overlays = useOverlaysStore();
const open = computed({
  get: () => overlays.inboxOpen,
  set: (v: boolean) => { overlays.inboxOpen = v; },
});
</script>

<template>
  <el-dialog
    v-model="open"
    title="📬 Messages"
    width="min(94vw, 1100px)"
    append-to-body
    destroy-on-close
    align-center
    class="overlay-dialog"
  >
    <InboxView v-if="open" />
  </el-dialog>
</template>

<style scoped lang="scss">
.overlay-dialog :deep(.el-dialog__body) {
  max-height: 80vh;
  overflow-y: auto;
  padding-top: 0;
}
</style>
